var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-6"},[(_vm.widthNow >= 550)?_c('Banner'):_c('BannerMobile'),(_vm.widthNow >= 550)?_c('MapCard'):_c('div',{staticStyle:{"margin-top":"2.5rem"}},[_c('MapCardMobile')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }